import * as React from "react";

import {
  usePlpPresenterForTheFilterMenu_Mobile,
  useProductListController_forFiltering,
  useProductListLoadingState,
  useProductListPresentationModel,
  useProductListState,
} from "../providers";

interface ActionBarProps {
  onClose: () => void;
}

export const ActionBar: React.FunctionComponent<ActionBarProps> = (props) => {
  const { isLoading: isLoadingProducts } = useProductListLoadingState();
  const { selectedOptions } = useProductListState();
  const { productCount } = useProductListPresentationModel();
  const { handleRemoveAllSelectedOptions } =
    useProductListController_forFiltering();

  const {
    whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile,
    doesTheExclusivelyOpenFilterSubMenu_onMobile_haveOptionsSelected,
    handleClearFilters_InTheExclusivelyOpenFilterSubMenu_onMobile,
  } = usePlpPresenterForTheFilterMenu_Mobile();

  const isClearFiltersButtonDisabled = React.useMemo(
    () =>
      isLoadingProducts ||
      !doesTheExclusivelyOpenFilterSubMenu_onMobile_haveOptionsSelected,
    [
      isLoadingProducts,
      whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile,
      selectedOptions,
      doesTheExclusivelyOpenFilterSubMenu_onMobile_haveOptionsSelected,
    ]
  );
  const clearFiltersButtonClass = `clear ${
    isClearFiltersButtonDisabled ? "disabled" : ""
  }`;

  const isClearAllButtonDisabled =
    isLoadingProducts || selectedOptions.length < 1;
  const clearAllButtonClass = `clear ${
    isClearAllButtonDisabled ? "disabled" : ""
  }`;

  const onClearFilters = () => {
    if (isClearFiltersButtonDisabled) {
      return;
    }
    handleClearFilters_InTheExclusivelyOpenFilterSubMenu_onMobile();
  };

  const onClearAll = () => {
    if (isClearAllButtonDisabled) {
      return;
    }
    handleRemoveAllSelectedOptions();
  };

  return (
    <div className="action-bar">
      {whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile ? (
        <button className={clearFiltersButtonClass} onClick={onClearFilters}>
          clear filters
        </button>
      ) : (
        <button className={clearAllButtonClass} onClick={onClearAll}>
          clear all
        </button>
      )}
      {isLoadingProducts ? (
        <button className="show loading">
          <p className="state-text">Loading</p>
          <div className="mini-spinner"></div>
        </button>
      ) : (
        <button
          className="show"
          onClick={props.onClose}
        >{`show ${productCount} items`}</button>
      )}
    </div>
  );
};
